export const tostSetting: any = {
    position: "bottom-right",
    autoClose: 2000,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "light",
}

export function createSound(sound:string) {
    let audio = new Audio();
    audio.src = sound;
    audio.autoplay = true;
}